<template>
  <div id="aid-order-detail">
    <H3>
      订单详情
      <template v-slot:suffix>订单状态：{{order.stateText}}</template>
    </H3>
    <a-steps :current="findActive(order)" class="card-step"  >
      <a-step v-for="s in status[order.order_type]" :key="s.state" :title="s.name">
        <!-- <a-icon slot="icon" type="right-circle" /> -->
        <template slot="content">{{s.name}}</template>
      </a-step>
    </a-steps>
    <a-descriptions title="订单信息" class="card" :column="6">
      <a-descriptions-item label>{{order.shop_no}} {{order.title}}</a-descriptions-item>
      <a-descriptions-item label="项目">{{order.project_title}}</a-descriptions-item>
      <a-descriptions-item label="下单时间">{{order.created_at*1000|datetime}}</a-descriptions-item>
      <a-descriptions-item
        v-if="order.deliver_date > 0"
        label="发货日期"
      >{{order.deliver_date|localDate}}</a-descriptions-item>
      <a-descriptions-item v-if="order.deadline > 0" label="到店日期">{{order.deadline*1000|datetime}}</a-descriptions-item>
      <a-descriptions-item label="订单类型">{{order.order_type|orderState}}</a-descriptions-item>
      <a-descriptions-item label="制造商">{{order.supplier}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="预约安装时间" class="card" :column="6" v-if="order.order_type == 1">
      <a-descriptions-item label>
        {{order.user.name }}
        <a :href="'tel:'+order.user.phone">{{order.user.phone}}</a>
      </a-descriptions-item>
      <a-descriptions-item label>{{order.appoint_install*1000|datetime}}</a-descriptions-item>
      <a-descriptions-item label></a-descriptions-item>
      <a-descriptions-item label></a-descriptions-item>
      <a-descriptions-item label></a-descriptions-item>
      <a-descriptions-item label></a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="签到信息" class="card" :column="6" v-if="order.order_type == 1">
      <a-descriptions-item label>安装 {{order.worker_count }} 人</a-descriptions-item>
      <a-descriptions-item label>{{order.arrive_location_date*1000|datetime}}</a-descriptions-item>
      <a-descriptions-item label>签到点距离门店 {{order.distance*1000}} m</a-descriptions-item>
      <a-descriptions-item label></a-descriptions-item>
      <a-descriptions-item label></a-descriptions-item>
      <a-descriptions-item label></a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="店铺平面图" class="card" :column="1" v-if="order.order_type == 1">
      <a-descriptions-item label>1F</a-descriptions-item>
      <a-descriptions-item label>
        <div class="img-box">
          <img
            class="img-floor"
            src="https://senkoo.oss-cn-shanghai.aliyuncs.com/api/source_0647_%E8%A5%BF%E5%AE%89%E9%AB%98%E6%96%B0%E4%B8%87%E8%BE%BE%E5%B9%BF%E5%9C%BA%E5%BA%97.jpg"
          />
          <a-button
            icon="download"
            shape="circle"
            class="btn-down"
            @click="down('https://senkoo.oss-cn-shanghai.aliyuncs.com/api/source_0647_%E8%A5%BF%E5%AE%89%E9%AB%98%E6%96%B0%E4%B8%87%E8%BE%BE%E5%B9%BF%E5%9C%BA%E5%BA%97.jpg')"
          ></a-button>
        </div>
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions title1="点位信息" class="card" :column="1" v-if="order.order_type == 1">
      <H3 slot="title">
        点位信息
        <span class="label" slot="suffix">点位数量 4</span>
      </H3>
      <a-descriptions-item label v-for="(p,idx) in order.points" :key="p.id">
        <Point :p="p" :rank="idx+1" />
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions
      title1="完工照片"
      layout="vertical"
      class="card"
      :column="1"
      v-if="order.order_type == 1"
    >
      <H3 slot="title">
        完工照片
        <span class="label" slot="suffix">点位数量 4</span>
      </H3>
      <a-descriptions-item label="开箱视频">
        <video
          class="install-video"
          :src="order1.unpackage_video&&order1.unpackage_video.length > 0&&order1.unpackage_video[0].url"
          controls="controls"
        />
      </a-descriptions-item>
      <a-descriptions-item label="现场问题照片">
        <Images :imgs="(order1.scene||[]).map(m => m.url)" title="现场问题照片" />
      </a-descriptions-item>
      <a-descriptions-item label="门头照片">
        <Images :imgs="(order1.install_head||[]).map(m => m.url)" title="门头照片" />
      </a-descriptions-item>
      <a-descriptions-item label="安装前照片">
        <Images :imgs="(order1.install_before||[]).map(m => m.url)" title="安装前照片" />
      </a-descriptions-item>
      <a-descriptions-item label="安装后照片">
        <Images :imgs="(order1.install_after||[]).map(m => m.url)" title="安装后照片" />
      </a-descriptions-item>
      <a-descriptions-item label="验收单">
        <Images :imgs="(order1.ident_sign||[]).map(m => m.url)" title="验收单" />
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
import H3 from "./H3";
import Point from "./Point";
import Images from "./Images";
import ImageList from "@/components/ImageList";
export default {
  components: { H3, Point, Images, ImageList },
  props: { id: { type: [String, Number], default: () => 325665 } },
  data() {
    return {
      status: {
        "0": [
          { name: "下单", state: 1, icon: "ordered" },
          { name: "色彩校验", state: 2, icon: "color-checked" },
          { name: "生产", state: 3, icon: "produced" },
          { name: "全家福", state: 4, icon: "family-checked" },
          { name: "已发货", state: 5, icon: "delivered" },
          { name: "已完成", state: 99, icon: "finished" }
        ],
        "1": [
          { name: "下单", state: 1, icon: "ordered" },
          { name: "色彩校验", state: 2, icon: "color-checked" },
          { name: "生产", state: 3, icon: "produced" },
          { name: "全家福", state: 4, icon: "family-checked" },
          { name: "已发货", state: 5, icon: "delivered" },
          { name: "待预约", state: 6, icon: "signed" },
          { name: "预约安装", state: 7, icon: "booked" },
          { name: "安装", state: 8, icon: "fixed" },
          { name: "验收单", state: 9, icon: "receipted" },
          { name: "审核", state: 10, icon: "audited" },
          { name: "已完成", state: 99, icon: "finished" }
        ],
        "2": [
          { name: "下单", state: 1, icon: "ordered" },
          { name: "待预约", state: 6, icon: "signed" },
          { name: "预约测量", state: 7, icon: "booked" },
          { name: "测量", state: 8, icon: "measured" },
          { name: "审核", state: 10, icon: "audited" },
          { name: "已完成", state: 99, icon: "finished" }
        ]
      },
      order1: {},
      order: {
        state: 99,
        stateText: "已完成",
        order_type: 1,
        shop_no: 647,
        title: "西安高新万达广场",
        project_title: "2020-07-16-647-店铺下单",
        created_at: "1594977755",
        supplier: "上海释空",
        deadline: 1595239200,
        user: { name: "石见山", phone: "18653291132" },
        appoint_install: 1595239200,
        worker_count: 3,
        arrive_location_date: 1595239190,
        distance: 0.8,
        points: [
          {
            id: 7213,
            location: "收银台",
            material: "可转移背胶",
            count: 7,
            size: "1200*1200",
            created_at: "2020-07-23",
            images: [
              "https://senkoo.oss-cn-shanghai.aliyuncs.com/api/wx397c8a22f16ad4b1.o6zAJsycEG1ebq1QZ1aFePDc-EOw.2I8QMcRqbyT99e52115151495b469c8e9d0925e2a3d2.jpg",
              "https://senkoo.oss-cn-shanghai.aliyuncs.com/api/wx397c8a22f16ad4b1.o6zAJsycEG1ebq1QZ1aFePDc-EOw.3Bt52GIEjXwP9e52115151495b469c8e9d0925e2a3d2.jpg",
              "https://senkoo.oss-cn-shanghai.aliyuncs.com/api/wx397c8a22f16ad4b1.o6zAJsycEG1ebq1QZ1aFePDc-EOw.O14A0NWVzL8N9e52115151495b469c8e9d0925e2a3d2.jpg"
            ]
          },
          {
            id: 7212,
            location: "店内壁面",
            material: "可转移背胶",
            count: 1,
            size: "1200*1200",
            created_at: "2020-07-23",
            images: [
              "https://senkoo.oss-cn-shanghai.aliyuncs.com/api/tmp_87d5cf19e949b24341f66ba16c8340809c0f41cc8b086f82.jpg"
            ]
          },
          {
            id: 7211,
            location: "店内壁面",
            material: "可转移背胶",
            count: 1,
            size: "1200*1200",
            created_at: "2020-07-23",
            images: [
              "https://senkoo.oss-cn-shanghai.aliyuncs.com/api/tmp_da89c776d56b0e14a91be66fafb28bde12bf50a018d4b1b2.jpg"
            ]
          },
          {
            id: 7210,
            location: "店内壁面",
            material: "可转移背胶",
            count: 1,
            size: "1200*1200",
            created_at: "2020-07-23",
            images: [
              "https://senkoo.oss-cn-shanghai.aliyuncs.com/api/tmp_a656fb2c82cf9a27fddff733e4361ba5.jpg"
            ]
          }
        ]
      }
    };
  },
  created() {
    this.fetchOrder();
  },
  methods: {
    down(url) {
      window.open(url);
    },
    findActive(order) {
      const steps = this.status[order.order_type];
      const idx = (steps || []).findIndex(f => f.state === order.state) || 0;
      console.log("steps:", steps, idx);
      return idx + 1;
    },
    fetchOrder(param = {}) {
      param.id = this.id;
      this.$store.dispatch("shop/getOrder", param).then(res => {
        this.order1 = res.order;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#aid-order-detail {
  // padding: ;
  .card-step {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .card {
    text-align: left;
    /deep/ .ant-descriptions-title {
      // padding-top: 12px;
      text-align: left;
      // padding-left: 30px;
      // align-self: start;
    }
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 12px 24px;
    margin-bottom: 24px;
    .img-box {
      position: relative;
      .img-floor {
        width: 180px;
        height: 180px;
        border: 1px solid #dcdcdc;
      }
      .btn-down {
        background: #000;
        color: #fff;
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }
    .label {
      font-size: 14px;
      color: #999;
    }
    .install-video {
      max-width: 120px;
      max-height: 240px;
    }
  }
}
</style>